export const FOCUSABLE_ITEM_ATTRIBUTE = 'data-focusable';
export const FOCUSED_ITEM_ATRRIBUTE = 'data-focused';
